import SignupPage from './SignupPage'
export default SignupPage